module.exports = __webpack_public_path__ + "static/logo-sombrero-restaurante-borrasco-80cac26993cb3c1f3b1b904011247dfd.png";